import { Drawer, Box, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { drawerWidth } from "config";
import { useMediaQuery } from "@mui/material";
import MiniDrawerStyled from "layouts/Drawer/MiniDrawerStyled";
import DrawerHeader from "layouts/Drawer/DrawerHeader";
import DrawerContent from "layouts/Drawer/DrawerContent";

const MainDrawer = ({ open, toggleMenu }) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"));
  const drawerHeader = useMemo(() => <DrawerHeader />, []);
  const drawerContent = useMemo(() => <DrawerContent />, []);
  return (
    <Box>
      {!matchDownMD ? (
        <MiniDrawerStyled open={open} variant="permanent">
          {drawerHeader}
          {drawerContent}
        </MiniDrawerStyled>
      ) : (
        <Drawer
          open={open}
          variant="temporary"
          ModalProps={{ keepMounted: true }}
          onClose={toggleMenu}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundImage: "none",
              boxShadow: "inherit",
            },
          }}
        >
          {drawerHeader}
          {drawerContent}
        </Drawer>
      )}
    </Box>
  );
};

export default MainDrawer;
